import React from 'react'
import Manager from '../../public/components/Manager'
import RequisitionDiv from './RequisitionDiv'
Ext.require('Ext.Toast')

const config = {
    buttons: [
    ],
    columns: [
        { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
        { _text: '申请人', field: 'Creator', minWidth: 150, search: true, flex: 1 },
        { _text: '请购单号', field: 'Number', minWidth: 150, search: true, flex: 1 },
        { _text: '物料名称', field: 'MaterialNames', renderer: o => o.join(','), minWidth: 150, search: true, sortable: false, flex: 1 },
        { _text: '申请部门', field: '_CreateDep', minWidth: 150, flex: 1 },
        { _text: '状态名称', field: 'StatusName', minWidth: 150, search: true, flex: 1 },
        { _text: '签核人', field: '_Signatory', minWidth: 150, flex: 1 },
        { _number: '支付金额', field: 'LCTaxAmount', minWidth: 150, flex: 1 },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        showDetail(props => <RequisitionDiv {...props} id={data.id} onSave={refreshPage} readOnly={true} />)
    }

}

export default props => <Manager {...props} config={config} />